





















































































































































































































































































































































































































































































































































































































































































































































import {ITableHeaders, TableHeaders} from '@/interfaces/components-data';
import {
    BootstrapSelectBox,
    Calc,
    CalcIndividualConfig,
    FindFiltersParams,
    SelectBox,
    StrategyOfPriceOpt,
    strategyOfPriceOptLabels,
} from '@/interfaces/global-data';
import {
    CalcIndividualConfigMap,
    CategoryStrategies,
    categoryStrategiesSet,
    categoryStrategiesSetShort, FilesPageParams,
    FileType,
    GetTaskInfo,
    IdAndName,
    Page,
    ParametersListQuery,
    ParametersListFilterData,
    AppliedFiltersData,
    ParamsListItem,
    ServerFile,
    TaskInfoFilterType,
    kviStrategiesSet,
    competitorsPriceMethodsSb,
    competitorsPriceStrategiesSb, newProductPriceStrategySb,
} from '@/interfaces/server-data';
interface IEnumObj {
    [key: string]: any;
}
import {EventBus} from '@/mixins/event-bus';
import { localizeFileStatusMessage, isWritingToDatabase } from '@/utils/backendValueLocalizer';
import Http from '@/mixins/http';
import {AxiosResponse} from 'axios';
import {BFormFile} from 'bootstrap-vue';
import {Component, Mixins, Prop} from 'vue-property-decorator';
import LocalData from '../mixins/local-data';
import Toast from '../mixins/toast';
import MarketSelect from "@/components/MarketSelect.vue";
import Files from "@/components/Files.vue";
import FileUpload from '@/components/UI/FileUpload.vue'
import ColumnTitleContent from "@/components/UI/Table/ColumnTitleContent.vue";

@Component({
    components: {ColumnTitleContent, Files, MarketSelect, FileUpload},
})
export default class ParamsList extends Mixins(LocalData, Toast, Http) {
    @Prop() readonly selectTradingId!: number | null;
    filesTableCurrentPage: number = 1;
    rulesListTableSize: number = 0;
    rulesListTable: any = [];
    tableDataRulesListTable: any = [];
    individualRulesListTable: any = [];
    individualRulesListTableSize: number = 0;
    individualRulesListTotalRows: number = 0;
    tableDataIndividualRulesListTable: any = [];
    filesTableTotalRows: number = 0;
    rulesListPagination: any = {
        current: 1,
        pageSize: 20,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ['20', '50', '100'],
        showTotal: (total: number) => (this as any).$t('shared.pagination.total', { total }),
    };
    filesPerPage: number = 20;
    noNeedToLoad = false;
    filtersApplied = false;
    activeParamsListTabKey: string = 'skuTabsRef';
    file: File | null = null;
    fileType: FileType = FileType.RULES;
    fileId: number = -1
    tableKey = 1;
    individualParamsFileId: number = -1
    progressCounter: number = 0;
    loadProgress: boolean = false;
    fileIdForDelete: number = -1;
    showDeleteFileModal: boolean = false;
    showWindow: boolean = false;
    showIndividualConfigModal: boolean = false;
    individualConfigArray: any = []

    defaultSelectBox: SelectBox<number | null> = {
        value: null,
        label: this.$t('regular.common.notSelected') as string,
    };
    defaultStringSelectBox: SelectBox<string> = {
        value: '',
        label: this.$t('regular.common.notSelected') as string,
    };
    defaultFilterValue = {value: -1, label: this.$t('regular.common.all') as string};
    secondDefaultFilterValue = {value: -2, label: this.$t('regular.common.notSelected') as string};
    defaultMultipleValue = [this.defaultFilterValue, this.secondDefaultFilterValue];

    users: Array<SelectBox<string>> = [this.defaultStringSelectBox];
    storeRegions: Array<SelectBox<number>> = this.defaultMultipleValue;
    storeFormats: Array<SelectBox<number>> = this.defaultMultipleValue;
    storeClusters: Array<SelectBox<number>> = this.defaultMultipleValue;
    groups: Array<SelectBox<number>> = this.defaultMultipleValue;
    categories: Array<SelectBox<number>> = this.defaultMultipleValue;
    subcategories: Array<SelectBox<number>> = this.defaultMultipleValue;

    sortQuery: ParametersListQuery = new ParametersListQuery();

    individualParams: IndividualParamsMap = {};

    filesTable: ServerFile[] = [];
    fields: any[] = [
        {
            dataIndex: 'fileResult',
            slots: {
                title: 'fileResultColumnTitle',
            },
            slotColumnTitleData: {
                text: this.$t('regular.columns.actions') as string,
                useWidthCoefficient: true,
                widthCoefficient: 2,
            },
            width: 50,
            ellipsis: true,
            scopedSlots: { customRender: "fileResult" },
        },
        {
            dataIndex: 'commonParams.updateInfo.updateDate',
            slots: {
                title: 'commonParams.updateInfo.updateDateColumnTitle',
            },
            slotColumnTitleData: {
                text: this.$t('regular.columns.changeTime') as string,
                useWidthCoefficient: true,
            },
            width: 80,
            ellipsis: true,
            customRender: (data: any) => data ? new Date(data).toLocaleString('ru-RU') : '',
        },
        {
            dataIndex: 'commonParams.updateInfo.updatedBy',
            slots: {
                title: 'commonParams.updateInfo.updatedByColumnTitle',
            },
            slotColumnTitleData: {
                text: this.$t('regular.columns.user') as string,
                useWidthCoefficient: true,
            },
            width: 80,
            ellipsis: true,
            customRender: (data: string) => data,
        },
        {
            dataIndex: 'storeFormat.name',
            slots: {
                title: 'storeFormat.nameColumnTitle',
            },
            slotColumnTitleData: {
                text: this.$t('regular.columns.formatChannel') as string,
                useWidthCoefficient: true,
            },
            width: 80,
            ellipsis: true,
            scopedSlots: {
                customRender: (data: any) => data,
                filterDropdown: 'storeFormatFilter',
                filterIcon: "storeFormatFilterIcon",
            },
        },
        {
            dataIndex: 'storeRegions[0].name',
            slots: {
                title: 'storeRegions[0].nameColumnTitle',
            },
            slotColumnTitleData: {
                text: this.$t('regular.columns.storeRegion') as string,
                useWidthCoefficient: true,
            },
            width: 80,
            ellipsis: true,
            scopedSlots: {
                customRender: (data: any) => data,
                filterDropdown: 'storeRegionsFilter',
                filterIcon: "storeRegionsFilterIcon",
            },
        },
        {
            dataIndex: 'storeCluster.name',
            slots: {
                title: 'storeCluster.nameColumnTitle',
            },
            slotColumnTitleData: {
                text: this.$t('regular.columns.storeCluster') as string,
                useWidthCoefficient: true,
            },
            width: 80,
            ellipsis: true,
            scopedSlots: {
                customRender: (data: any) => data,
                filterDropdown: 'storeClusterFilter',
                filterIcon: "storeClusterFilterIcon",
            },
        },
        {
            dataIndex: 'group.name',
            slots: {
                title: 'group.nameColumnTitle',
            },
            slotColumnTitleData: {
                text: this.$t('regular.columns.productGroup') as string,
                useWidthCoefficient: true,
            },
            width: 80,
            ellipsis: true,
            scopedSlots: {
                customRender: (data: any) => data,
                filterDropdown: 'groupFilter',
                filterIcon: "groupFilterIcon",
            },
        },
        {
            dataIndex: 'category.name',
            slots: {
                title: 'category.nameColumnTitle',
            },
            slotColumnTitleData: {
                text: this.$t('regular.columns.productCategory') as string,
                useWidthCoefficient: true,
            },
            width: 80,
            ellipsis: true,
            scopedSlots: {
                customRender: (data: any) => data,
                filterDropdown: 'categoryFilter',
                filterIcon: "categoryFilterIcon",
            },
        },
        {
            dataIndex: 'subcategories[0].name',
            slots: {
                title: 'subcategories[0].nameColumnTitle',
            },
            slotColumnTitleData: {
                text: this.$t('regular.columns.productSubcategory') as string,
                useWidthCoefficient: true,
            },
            width: 80,
            ellipsis: true,
            scopedSlots: {
                customRender: (data: any) => data,
                filterDropdown: 'subcategoriesFilter',
                filterIcon: "subcategoriesFilterIcon",
            },
        },
        {
            dataIndex: 'categoryStrategy',
            slots: {
                title: 'categoryStrategyColumnTitle',
            },
            slotColumnTitleData: {
                text: this.$t('regular.levels.categoryStrategy') as string,
                useWidthCoefficient: true,
            },
            width: 120,
            ellipsis: true,
            customRender: (data: CategoryStrategies) => categoryStrategiesSetShort[data],
        },
        {
            dataIndex: 'commonParams.strategyValidityBeginDate',
            slots: {
                title: 'commonParams.strategyValidityBeginDateColumnTitle',
            },
            slotColumnTitleData: {
                text: this.$t('regular.columns.categoryStrategyStartDate') as string,
                useWidthCoefficient: true,
            },
            width: 134,
            ellipsis: true,
            customRender: this.formatStrategyValidityDate,
        },
        {
            dataIndex: 'commonParams.strategyValidityEndDate',
            slots: {
                title: 'commonParams.strategyValidityEndDateColumnTitle',
            },
            slotColumnTitleData: {
                text: this.$t('regular.columns.categoryStrategyEndDate') as string,
                useWidthCoefficient: true,
            },
            width: 134,
            ellipsis: true,
            customRender: this.formatStrategyValidityDate,
        },
        {
            dataIndex: 'commonParams.priceOpt',
            slots: {
                title: 'commonParams.priceOptColumnTitle',
            },
            slotColumnTitleData: {
                text: this.$t('regular.columns.priceOptStrategy') as string,
                useWidthCoefficient: true,
            },
            width: 80,
            ellipsis: true,
            customRender: (data: StrategyOfPriceOpt) => strategyOfPriceOptLabels[data],
        },
        {
            dataIndex: 'commonParams.marginalProfit',
            slots: {
                title: 'commonParams.marginalProfitColumnTitle',
            },
            slotColumnTitleData: {
                text: this.$t('regular.columns.minSkuProfitFull') as string,
                useWidthCoefficient: true,
            },
            width: 80,
            ellipsis: true,
            scopedSlots: {
                customRender: (data: any) => data,
            },
        },
        {
            dataIndex: 'commonParams.priceIncreaseLimit',
            slots: {
                title: 'commonParams.priceIncreaseLimitColumnTitle',
            },
            slotColumnTitleData: {
                text: this.$t('regular.rules.maxPriceIncreaseExcluding') as string,
                useWidthCoefficient: true,
            },
            width: 80,
            ellipsis: true,
            customRender: (data: any) => data,
        },
        {
            dataIndex: 'commonParams.priceDecreaseLimit',
            slots: {
                title: 'commonParams.priceDecreaseLimitColumnTitle',
            },
            slotColumnTitleData: {
                text: this.$t('regular.rules.maxPriceReductionExcluding') as string,
                useWidthCoefficient: true,
            },
            width: 120,
            ellipsis: true,
            customRender: (data: any) => data,
        },
        {
            dataIndex: 'commonParams.periodPriceIncreaseLimit',
            slots: {
                title: 'commonParams.periodPriceIncreaseLimitColumnTitle',
            },
            slotColumnTitleData: {
                text: this.$t('regular.columns.periodIncreaseLimitPercent') as string,
                useWidthCoefficient: true,
            },
            width: 120,
            ellipsis: true,
            customRender: (data: any) => data,
        },
        {
            dataIndex: 'commonParams.priceChangeLimit',
            slots: {
                title: 'commonParams.priceChangeLimitColumnTitle',
            },
            slotColumnTitleData: {
                text: this.$t('regular.rules.priceChangeLimit') as string,
                useWidthCoefficient: true,
            },
            width: 120,
            ellipsis: true,
            customRender: (data: any) => data,
        },
        {
            dataIndex: 'commonParams.priceChangeLimitKvi',
            slots: {
              title: 'commonParams.priceChangeLimitKviColumnTitle',
            },
            slotColumnTitleData: {
              text: this.$t('regular.kvi.priceChangeLimit') as string,
              useWidthCoefficient: true,
            },
            width: 120,
            ellipsis: true,
            customRender: (data: any) => data,
        },
        {
            dataIndex: 'commonParams.priceChangeLimitComp',
            slots: {
              title: 'commonParams.priceChangeLimitCompColumnTitle',
            },
            slotColumnTitleData: {
              text: this.$t('regular.competitive.cpoPriceChangeLimit') as string,
              useWidthCoefficient: true,
            },
            width: 120,
            ellipsis: true,
            customRender: (data: any) => data,
        },
        {
            dataIndex: 'commonParams.period',
            slots: {
                title: 'commonParams.periodColumnTitle',
            },
            slotColumnTitleData: {
                text: this.$t('regular.columns.period') as string,
                useWidthCoefficient: true,
            },
            width: 120,
            ellipsis: true,
            customRender: (data: any) => data,
        },
        {
            dataIndex: 'commonParams.backBasketPart',
            slots: {
                title: 'commonParams.backBasketPartColumnTitle',
            },
            slotColumnTitleData: {
                text: this.$t('regular.rules.backbasketShare') as string,
                useWidthCoefficient: true,
            },
            width: 120,
            ellipsis: true,
            customRender: (data: any) => data,
        },
        {
            dataIndex: 'commonParams.revaluationCalculateParams.useRevaluationCalculate',
            slots: {
                title: 'commonParams.revaluationCalculateParams.useRevaluationCalculateColumnTitle',
            },
            slotColumnTitleData: {
                text: this.$t('regular.calcParams.revaluationVolumeLimit') as string,
                useWidthCoefficient: true,
            },
            width: 120,
            ellipsis: true,
            customRender: (data: any) => this.toYesOrNo(data),
        },
        {
            dataIndex: 'commonParams.revaluationCalculateParams.revaluationNumber',
            slots: {
                title: 'commonParams.revaluationCalculateParams.revaluationNumberColumnTitle',
            },
            slotColumnTitleData: {
                text: this.$t('regular.calcParams.revaluationFrequency') as string,
                useWidthCoefficient: true,
            },
            width: 120,
            ellipsis: true,
            customRender: (data: any) => data,
        },
        {
            dataIndex: 'commonParams.revaluationCalculateParams.revaluationFrequencyCalculationDepth',
            slots: {
                title: 'commonParams.revaluationCalculateParams.revaluationFrequencyCalculationDepthColumnTitle',
            },
            slotColumnTitleData: {
                text: this.$t('regular.calcParams.periodDays') as string,
                useWidthCoefficient: true,
            },
            width: 120,
            ellipsis: true,
            customRender: (data: any) => data,
        },
        {
            dataIndex: 'commonParams.revaluationCalculateParams.calculateByAllCompetitors',
            slots: {
                title: 'commonParams.revaluationCalculateParams.calculateByAllCompetitorsColumnTitle',
            },
            slotColumnTitleData: {
                text: this.$t('regular.calcParams.allCompetitorPrices') as string,
                useWidthCoefficient: true,
            },
            width: 120,
            ellipsis: true,
            customRender: (data: any) => this.toYesOrNo(data),
        },
        {
            dataIndex: 'commonParams.isFixPricePromo',
            slots: {
                title: 'commonParams.isFixPricePromoColumnTitle',
            },
            slotColumnTitleData: {
                text: this.$t('regular.calcParams.fixPromoPrices') as string,
                useWidthCoefficient: true,
            },
            width: 120,
            ellipsis: true,
            customRender: (data: any) => this.toYesOrNo(data),
        },
        {
            dataIndex: 'commonParams.revaluationCalculateParams.purchasePriceDelta',
            slots: {
                title: 'commonParams.revaluationCalculateParams.purchasePriceDeltaColumnTitle',
            },
            slotColumnTitleData: {
                text: this.$t('regular.calcParams.purchasePriceDeviation') as string,
                useWidthCoefficient: true,
            },
            width: 120,
            ellipsis: true,
            customRender: (data: any) => data,
        },
        {
            dataIndex: 'commonParams.revaluationCalculateParams.competitorsPriceDelta',
            slots: {
                title: 'commonParams.revaluationCalculateParams.competitorsPriceDeltaColumnTitle',
            },
            slotColumnTitleData: {
                text: this.$t('regular.calcParams.cpoDeviation') as string,
                useWidthCoefficient: true,
            },
            width: 120,
            ellipsis: true,
            customRender: (data: any) => data,
        },
        {
            dataIndex: 'commonParams.checkMarginDeclineProfit',
            slots: {
                title: 'commonParams.checkMarginDeclineProfitColumnTitle',
            },
            slotColumnTitleData: {
                text: this.$t('regular.rules.checkProfReductionLimit') as string,
                useWidthCoefficient: true,
            },
            width: 120,
            ellipsis: true,
            customRender: (data: any) => this.toYesOrNo(data),
        },
        {
            dataIndex: 'commonParams.declineProfitabilityPc',
            slots: {
                title: 'commonParams.declineProfitabilityPcColumnTitle',
            },
            slotColumnTitleData: {
                text: this.$t('regular.rules.profReductionLimit') as string,
                useWidthCoefficient: true,
            },
            width: 120,
            ellipsis: true,
            customRender: (data: any) => data,
        },
        {
            dataIndex: 'commonParams.searchPreviousPricesDepth',
            slots: {
                title: 'commonParams.searchPreviousPricesDepthColumnTitle',
            },
            slotColumnTitleData: {
                text: this.$t('regular.rules.prevPriceSearchDepth') as string,
                useWidthCoefficient: true,
            },
            width: 120,
            ellipsis: true,
            customRender: (data: any) => data,
        },
        {
            dataIndex: 'commonParams.compensateLowerTargets',
            slots: {
                title: 'commonParams.compensateLowerTargetsColumnTitle',
            },
            slotColumnTitleData: {
                text: this.$t('regular.rules.compensateTargetReduction') as string,
                useWidthCoefficient: true,
            },
            width: 120,
            ellipsis: true,
            customRender: (data: any) => this.toYesOrNo(data),
        },
        {
            dataIndex: 'commonParams.competitorsPricesParams',
            slots: {
                title: 'commonParams.competitorsPricesParamsColumnTitle',
            },
            slotColumnTitleData: {
                text: this.$t('regular.competitive.controlParam') as string,
                useWidthCoefficient: true,
            },
            width: 120,
            ellipsis: true,
            customRender: (data: any) => data,
        },
        {
            dataIndex: 'commonParams.kviStrategy',
            slots: {
                title: 'commonParams.kviStrategyColumnTitle',
            },
            slotColumnTitleData: {
                text: this.$t('regular.columns.kviStrategy') as string,
                useWidthCoefficient: true,
            },
            width: 120,
            ellipsis: true,
            customRender: (value: string) => this.getLabelFromEnum(kviStrategiesSet, value),
        },
        {
            dataIndex: 'commonParams.percentageOfCompetitorsPrice',
            slots: {
                title: 'commonParams.percentageOfCompetitorsPriceColumnTitle',
            },
            slotColumnTitleData: {
                text: this.$t('regular.columns.adjustmentByKvi') as string,
                useWidthCoefficient: true,
            },
            width: 120,
            ellipsis: true,
            customRender: (data: any) => data,
        },
        {
            dataIndex: 'commonParams.minProfitKVI',
            slots: {
                title: 'commonParams.minProfitKVIColumnTitle',
            },
            slotColumnTitleData: {
                text: this.$t('regular.kvi.minProfitability') as string,
                useWidthCoefficient: true,
            },
            width: 120,
            ellipsis: true,
            customRender: (data: any) => data,
        },
        {
            dataIndex: 'commonParams.kviPriceDecreaseLimit',
            slots: {
                title: 'commonParams.kviPriceDecreaseLimitColumnTitle',
            },
            slotColumnTitleData: {
                text: this.$t('regular.kvi.reductionLimit') as string,
                useWidthCoefficient: true,
            },
            width: 120,
            ellipsis: true,
            customRender: (data: any) => data,
        },
        {
            dataIndex: 'commonParams.useCompetitorsPrices',
            slots: {
                title: 'commonParams.useCompetitorsPricesColumnTitle',
            },
            slotColumnTitleData: {
                text: this.$t('regular.competitive.considerCompetitorPrices') as string,
                useWidthCoefficient: true,
            },
            width: 120,
            ellipsis: true,
            customRender: (data: any) => this.toYesOrNo(data),
        },
        {
            dataIndex: 'commonParams.byPromoPrices',
            slots: {
                title: 'commonParams.byPromoPricesColumnTitle',
            },
            slotColumnTitleData: {
                text: this.$t('regular.competitive.considerPromoPrices') as string,
                useWidthCoefficient: true,
            },
            width: 120,
            ellipsis: true,
            customRender: (data: any) => this.toYesOrNo(data),
        },
        {
            dataIndex: 'commonParams.competitorPriceControlParameterPc',
            slots: {
                title: 'commonParams.competitorPriceControlParameterPcColumnTitle',
            },
            slotColumnTitleData: {
                text: this.$t('regular.columns.competitorPriceControlParam') as string,
                useWidthCoefficient: true,
            },
            width: 120,
            ellipsis: true,
            customRender: (data: any) => data,
        },
        {
            dataIndex: 'commonParams.percentileType',
            slots: {
                title: 'commonParams.percentileTypeColumnTitle',
            },
            slotColumnTitleData: {
                text: this.$t('regular.competitive.percentiles') as string,
                useWidthCoefficient: true,
            },
            width: 120,
            ellipsis: true,
            customRender: (data: any) => data,
        },
        {
            dataIndex: 'commonParams.competitorsPriceMethod',
            slots: {
                title: 'commonParams.competitorsPriceMethodColumnTitle',
            },
            slotColumnTitleData: {
                text: this.$t('regular.competitive.priorityCalcMethod') as string,
                useWidthCoefficient: true,
            },
            width: 120,
            ellipsis: true,
            customRender: (value: string) => this.getLabelFromEnum(competitorsPriceMethodsSb, value),
        },
        {
            dataIndex: 'commonParams.competitorsPriceStrategy',
            slots: {
                title: 'commonParams.competitorsPriceStrategyColumnTitle',
            },
            slotColumnTitleData: {
                text: this.$t('regular.competitive.competitivePriceStrategy') as string,
                useWidthCoefficient: true,
            },
            width: 120,
            ellipsis: true,
            customRender: (value: string) => this.getLabelFromEnum(competitorsPriceStrategiesSb, value),
        },
        {
            dataIndex: 'commonParams.compPriceDecreaseLimit',
            slots: {
                title: 'commonParams.compPriceDecreaseLimitColumnTitle',
            },
            slotColumnTitleData: {
                text: this.$t('regular.competitive.cpoReductionLimit') as string,
                useWidthCoefficient: true,
            },
            width: 120,
            ellipsis: true,
            customRender: (data: any) => data,
        },
        {
            dataIndex: 'commonParams.competitorsPriceAdjustment',
            slots: {
                title: 'commonParams.competitorsPriceAdjustmentColumnTitle',
            },
            slotColumnTitleData: {
                text: this.$t('regular.columns.adjustmentByCpo') as string,
                useWidthCoefficient: true,
            },
            width: 120,
            ellipsis: true,
            customRender: (data: any) => data,
        },
        {
            dataIndex: 'commonParams.calculateCompAllowedDeviation',
            slots: {
                title: 'commonParams.calculateCompAllowedDeviationColumnTitle',
            },
            slotColumnTitleData: {
                text: this.$t('regular.competitive.autoDeviation') as string,
                useWidthCoefficient: true,
            },
            width: 120,
            ellipsis: true,
            customRender: (data: any) => this.toYesOrNo(data),
        },
        {
            dataIndex: 'commonParams.competitorsControlParam',
            slots: {
                title: 'commonParams.competitorsControlParamColumnTitle',
            },
            slotColumnTitleData: {
                text: this.$t('regular.competitive.allowableDeviation') as string,
                useWidthCoefficient: true,
            },
            width: 120,
            ellipsis: true,
            customRender: (data: any) => data,
        },
        {
            dataIndex: 'commonParams.competitorsPricePeriod',
            slots: {
                title: 'commonParams.competitorsPricePeriodColumnTitle',
            },
            slotColumnTitleData: {
                text: this.$t('regular.competitive.priceValidityDays') as string,
                useWidthCoefficient: true,
            },
            width: 120,
            ellipsis: true,
            customRender: (data: any) => data,
        },
        {
            dataIndex: 'commonParams.daysToPriceChangeStart',
            slots: {
                title: 'commonParams.daysToPriceChangeStartColumnTitle',
            },
            slotColumnTitleData: {
                text: this.$t('regular.competitive.daysBeforePriceStart') as string,
                useWidthCoefficient: true,
            },
            width: 120,
            ellipsis: true,
            customRender: (data: any) => data,
        },
        {
            dataIndex: 'commonParams.daysToPriceChangeFinish',
            slots: {
                title: 'commonParams.daysToPriceChangeFinishColumnTitle',
            },
            slotColumnTitleData: {
                text: this.$t('regular.competitive.daysBeforePriceEnd') as string,
                useWidthCoefficient: true,
            },
            width: 120,
            ellipsis: true,
            customRender: (data: any) => data,
        },
        {
            dataIndex: 'commonParams.competitorsInfluencesCoef',
            slots: {
                title: 'commonParams.competitorsInfluencesCoefColumnTitle',
            },
            slotColumnTitleData: {
                text: this.$t('regular.competitive.competitorInfluenceCoeff') as string,
                useWidthCoefficient: true,
            },
            width: 120,
            ellipsis: true,
            customRender: (data: any) => data,
        },
        {
            dataIndex: 'commonParams.competitorsMinimumProfit',
            slots: {
                title: 'commonParams.competitorsMinimumProfitColumnTitle',
            },
            slotColumnTitleData: {
                text: this.$t('regular.competitive.minProfSkuCpo') as string,
                useWidthCoefficient: true,
            },
            width: 120,
            ellipsis: true,
            customRender: (data: any) => data,
        },
        {
            dataIndex: 'commonParams.newProductPriceStrategy',
            slots: {
                title: 'commonParams.newProductPriceStrategyColumnTitle',
            },
            slotColumnTitleData: {
                text: this.$t('regular.columns.newProductPricingStrategy') as string,
                useWidthCoefficient: true,
            },
            width: 130,
            ellipsis: true,
            customRender: (value: string) => this.getLabelFromEnum(newProductPriceStrategySb, value),
        },
        {
            dataIndex: 'commonParams.priceGapCtmPc',
            slots: {
                title: 'commonParams.priceGapCtmPcColumnTitle',
            },
            slotColumnTitleData: {
                text: this.$t('regular.advancedPricing.ctmPriceGap') as string,
                useWidthCoefficient: true,
            },
            width: 120,
            ellipsis: true,
            customRender: (data: any) => data,
        },
        {
            dataIndex: 'commonParams.priceGap',
            slots: {
                title: 'commonParams.priceGapColumnTitle',
            },
            slotColumnTitleData: {
                text: this.$t('regular.columns.priceGapPercent') as string,
                useWidthCoefficient: true,
            },
            width: 120,
            ellipsis: true,
            customRender: (data: any) => data,
        },
        {
            dataIndex: 'commonParams.newProductLifespanInDays',
            slots: {
                title: 'commonParams.newProductLifespanInDaysColumnTitle',
            },
            slotColumnTitleData: {
                text: this.$t('regular.columns.newProductLifeDays') as string,
                useWidthCoefficient: true,
            },
            width: 120,
            ellipsis: true,
            customRender: (data: any) => data,
        },
        {
            dataIndex: 'commonParams.recalculateCtm',
            slots: {
                title: 'commonParams.recalculateCtmColumnTitle',
            },
            slotColumnTitleData: {
                text: this.$t('regular.advancedPricing.autoCtmBrandTarget') as string,
                useWidthCoefficient: true,
            },
            width: 120,
            ellipsis: true,
            customRender: (data: any) => this.toYesOrNo(data),
        },
        {
            dataIndex: 'commonParams.priceFamilies',
            slots: {
                title: 'commonParams.priceFamiliesColumnTitle',
            },
            slotColumnTitleData: {
                text: this.$t('regular.advancedPricing.priceFamilies') as string,
                useWidthCoefficient: true,
            },
            width: 120,
            ellipsis: true,
            customRender: (data: any) => this.toYesOrNo(data),
        },
        {
            dataIndex: 'commonParams.hardPriceFamilies',
            slots: {
                title: 'commonParams.hardPriceFamiliesColumnTitle',
            },
            slotColumnTitleData: {
                text: this.$t('regular.advancedPricing.strictPriceFamilies') as string,
                useWidthCoefficient: true,
            },
            width: 120,
            ellipsis: true,
            customRender: (data: any) => this.toYesOrNo(data),
        },
        {
            dataIndex: 'commonParams.calculationDepth',
            slots: {
                title: 'commonParams.calculationDepthColumnTitle',
            },
            slotColumnTitleData: {
                text: this.$t('regular.calcParams.calcDepthWeeks') as string,
                useWidthCoefficient: true,
            },
            width: 120,
            ellipsis: true,
            customRender: (data: any) => data,
        },
        {
            dataIndex: 'commonParams.calculationDay',
            slots: {
                title: 'commonParams.calculationDayColumnTitle',
            },
            slotColumnTitleData: {
                text: this.$t('regular.calcParams.forecastPeriodDays') as string,
                useWidthCoefficient: true,
            },
            width: 120,
            ellipsis: true,
            customRender: (data: any) => data,
        },
        {
            dataIndex: 'commonParams.countPriceBySkuWithoutBatches',
            slots: {
                title: 'commonParams.countPriceBySkuWithoutBatchesColumnTitle',
            },
            slotColumnTitleData: {
                text: this.$t('regular.calcParams.priceBySkuNoBatches') as string,
                useWidthCoefficient: true,
            },
            width: 120,
            ellipsis: true,
            customRender: (data: any) => this.toYesOrNo(data),
        },
        {
            dataIndex: 'commonParams.countByAvgPurchasePrice',
            slots: {
                title: 'commonParams.countByAvgPurchasePriceColumnTitle',
            },
            slotColumnTitleData: {
                text: this.$t('regular.calcParams.weightedAvgPurchasePrice') as string,
                useWidthCoefficient: true,
            },
            width: 120,
            ellipsis: true,
            customRender: (data: any) => this.toYesOrNo(data),
        },
        {
            dataIndex: 'commonParams.calcPurchasePriceByClusters',
            slots: {
                title: 'commonParams.calcPurchasePriceByClustersColumnTitle',
            },
            slotColumnTitleData: {
                text: this.$t('regular.calcParams.purchasePriceRegionLevel') as string,
                useWidthCoefficient: true,
            },
            width: 120,
            ellipsis: true,
            customRender: (data: any) => this.toYesOrNo(data),
        },
        {
            dataIndex: 'commonParams.useEmptyRemains',
            slots: {
                title: 'commonParams.useEmptyRemainsColumnTitle',
            },
            slotColumnTitleData: {
                text: this.$t('regular.calcParams.considerZeroStock') as string,
                useWidthCoefficient: true,
            },
            width: 120,
            ellipsis: true,
            customRender: (data: any) => this.toYesOrNo(data),
        },
        {
            dataIndex: 'commonParams.useArrivalDate',
            slots: {
                title: 'commonParams.useArrivalDateColumnTitle',
            },
            slotColumnTitleData: {
                text: this.$t('regular.calcParams.considerArrivalDate') as string,
                useWidthCoefficient: true,
            },
            width: 120,
            ellipsis: true,
            customRender: (data: any) => this.toYesOrNo(data),
        },
        {
            dataIndex: 'commonParams.depthToPurchasePrice',
            slots: {
                title: 'commonParams.depthToPurchasePriceColumnTitle',
            },
            slotColumnTitleData: {
                text: this.$t('regular.calcParams.purchasePriceDepthWeeks') as string,
                useWidthCoefficient: true,
            },
            width: 120,
            ellipsis: true,
            customRender: (data: any) => data,
        },
        {
            dataIndex: 'commonParams.countAtMaxPurchasePrice',
            slots: {
                title: 'commonParams.countAtMaxPurchasePriceColumnTitle',
            },
            slotColumnTitleData: {
                text: this.$t('regular.calcParams.useMaxPurchasePrice') as string,
                useWidthCoefficient: true,
            },
            width: 120,
            ellipsis: true,
            customRender: (data: any) => this.toYesOrNo(data),
        },
        {
            dataIndex: 'commonParams.countAtFuturePurchasePrice',
            slots: {
                title: 'commonParams.countAtFuturePurchasePriceColumnTitle',
            },
            slotColumnTitleData: {
                text: this.$t('regular.calcParams.useFuturePurchasePrice') as string,
                useWidthCoefficient: true,
            },
            width: 120,
            ellipsis: true,
            customRender: (data: any) => this.toYesOrNo(data),
        },
        {
            dataIndex: 'commonParams.changePriceCorridor',
            slots: {
                title: 'commonParams.changePriceCorridorColumnTitle',
            },
            slotColumnTitleData: {
                text: this.$t('regular.calcParams.changePriceCorridor') as string,
                useWidthCoefficient: true,
            },
            width: 130,
            ellipsis: true,
            customRender: (data: any) => this.toYesOrNo(data),
        },
        {
            dataIndex: 'commonParams.fixLowerBorder',
            slots: {
                title: 'commonParams.fixLowerBorderColumnTitle',
            },
            slotColumnTitleData: {
                text: this.$t('regular.calcParams.fixLowerBound') as string,
                useWidthCoefficient: true,
            },
            width: 120,
            ellipsis: true,
            customRender: (data: any) => this.toYesOrNo(data),
        },
        {
            dataIndex: 'commonParams.calculateByRegression',
            slots: {
                title: 'commonParams.calculateByRegressionColumnTitle',
            },
            slotColumnTitleData: {
                text: this.$t('regular.calcParams.calcByElasticity') as string,
                useWidthCoefficient: true,
            },
            width: 120,
            ellipsis: true,
            customRender: (data: boolean) => this.toYesOrNo(!data),
        },
        {
            dataIndex: 'commonParams.useAllProductBatchNumbers',
            slots: {
                title: 'commonParams.useAllProductBatchNumbersColumnTitle',
            },
            slotColumnTitleData: {
                text: this.$t('regular.calcParams.differentBatches') as string,
                useWidthCoefficient: true,
            },
            width: 120,
            ellipsis: true,
            customRender: (data: any) => this.toYesOrNo(data),
        },
        {
            dataIndex: 'commonParams.allCheck',
            slots: {
                title: 'commonParams.allCheckColumnTitle',
            },
            slotColumnTitleData: {
                text: this.$t('regular.calcParams.receiptsAsSingleNumber') as string,
                useWidthCoefficient: true,
            },
            width: 120,
            ellipsis: true,
            customRender: (data: any) => this.toYesOrNo(data),
        },
        {
            dataIndex: 'commonParams.discountPrise',
            slots: {
                title: 'commonParams.discountPriseColumnTitle',
            },
            slotColumnTitleData: {
                text: this.$t('regular.calcParams.priceInReceipt') as string,
                useWidthCoefficient: true,
            },
            width: 120,
            ellipsis: true,
            customRender: (data: any) => this.toYesOrNo(data),
        },
        {
            dataIndex: 'commonParams.calculatePYR',
            slots: {
                title: 'commonParams.calculatePYRColumnTitle',
            },
            slotColumnTitleData: {
                text: this.$t('regular.calcParams.usePreviousYearData') as string,
                useWidthCoefficient: true,
            },
            width: 120,
            ellipsis: true,
            customRender: (data: any) => this.toYesOrNo(data),
        },
        {
            dataIndex: 'commonParams.inflation',
            slots: {
                title: 'commonParams.inflationColumnTitle',
            },
            slotColumnTitleData: {
                text: this.$t('regular.calcParams.considerInflation') as string,
                useWidthCoefficient: true,
            },
            width: 120,
            ellipsis: true,
            customRender: (data: any) => this.toYesOrNo(data),
        },
        {
            dataIndex: 'commonParams.calculateBySpeedSale',
            slots: {
                title: 'commonParams.calculateBySpeedSaleColumnTitle',
            },
            slotColumnTitleData: {
                text: this.$t('regular.calcParams.considerSalesSpeed') as string,
                useWidthCoefficient: true,
            },
            width: 120,
            ellipsis: true,
            customRender: (data: any) => this.toYesOrNo(data),
        },
        {
            dataIndex: 'commonParams.allClaster',
            slots: {
                title: 'commonParams.allClasterColumnTitle',
            },
            slotColumnTitleData: {
                text: this.$t('regular.calcParams.elasticityAllClusters') as string,
                useWidthCoefficient: true,
            },
            width: 120,
            ellipsis: true,
            customRender: (data: any) => this.toYesOrNo(data),
        },
        {
            dataIndex: 'commonParams.forecastAccuracy',
            slots: {
                title: 'commonParams.forecastAccuracyColumnTitle',
            },
            slotColumnTitleData: {
                text: this.$t('regular.calcParams.forecastAccuracy') as string,
                useWidthCoefficient: true,
            },
            width: 120,
            ellipsis: true,
            customRender: (data: any) => this.toYesOrNo(data),
        },
        {
            dataIndex: 'commonParams.thompsonSampling',
            slots: {
                title: 'commonParams.thompsonSamplingColumnTitle',
            },
            slotColumnTitleData: {
                text: this.$t('regular.rules.probabilisticApproach') as string,
                useWidthCoefficient: true,
            },
            width: 120,
            ellipsis: true,
            customRender: (data: any) => this.toYesOrNo(data),
        },
        {
            dataIndex: 'commonParams.applyOmnichannel',
            slots: {
                title: 'commonParams.applyOmnichannelColumnTitle',
            },
            slotColumnTitleData: {
                text: this.$t('regular.calcParams.omnichannelRules') as string,
                useWidthCoefficient: true,
            },
            width: 120,
            ellipsis: true,
            customRender: (data: any) => this.toYesOrNo(data),
        },
        {
            dataIndex: 'commonParams.spreadByPriceSegments',
            slots: {
                title: 'commonParams.spreadByPriceSegmentsColumnTitle',
            },
            slotColumnTitleData: {
                text: this.$t('regular.priceSegments.alignBySegments') as string,
                useWidthCoefficient: true,
            },
            width: 120,
            ellipsis: true,
            customRender: (data: any) => this.toYesOrNo(data),
        },
        {
            dataIndex: 'commonParams.findAutomaticallyPriceSegments',
            slots: {
                title: 'commonParams.findAutomaticallyPriceSegmentsColumnTitle',
            },
            slotColumnTitleData: {
                text: this.$t('regular.priceSegments.autoDetect') as string,
                useWidthCoefficient: true,
            },
            width: 120,
            ellipsis: true,
            customRender: (data: any) => this.toYesOrNo(data),
        },
        {
            dataIndex: 'commonParams.countPriceSegments',
            slots: {
                title: 'commonParams.countPriceSegmentsColumnTitle',
            },
            slotColumnTitleData: {
                text: this.$t('regular.priceSegments.segmentCount') as string,
                useWidthCoefficient: true,
            },
            width: 120,
            ellipsis: true,
            customRender: (data: any) => data,
        },
        {
            dataIndex: 'commonParams.autoApprovalParams.useAutoApproval',
            slots: {
                title: 'commonParams.autoApprovalParams.useAutoApprovalColumnTitle',
            },
            slotColumnTitleData: {
                text: this.$t('regular.columns.autoApprovalUse') as string,
                useWidthCoefficient: true,
            },
            width: 100,
            ellipsis: true,
            customRender: (data: any) => this.toYesOrNo(data),
        },
        {
            dataIndex: 'commonParams.autoApprovalParams.priceChangeFrom',
            slots: {
                title: 'commonParams.autoApprovalParams.priceChangeFromColumnTitle',
            },
            slotColumnTitleData: {
                text: this.$t('regular.columns.autoApprovalPriceChangeFrom') as string,
                useWidthCoefficient: true,
            },
            width: 100,
            ellipsis: true,
            customRender: (data: any) => data != null ? data : '',
        },
        {
            dataIndex: 'commonParams.autoApprovalParams.priceChangeTo',
            slots: {
                title: 'commonParams.autoApprovalParams.priceChangeToColumnTitle',
            },
            slotColumnTitleData: {
                text: this.$t('regular.columns.autoApprovalPriceChangeTo') as string,
                useWidthCoefficient: true,
            },
            width: 100,
            ellipsis: true,
            customRender: (data: any) => data != null ? data : '',
        },
        {
            dataIndex: 'commonParams.autoApprovalParams.marginChangeFrom',
            slots: {
                title: 'commonParams.autoApprovalParams.marginChangeFromColumnTitle',
            },
            slotColumnTitleData: {
                text: this.$t('regular.columns.autoApprovalMarginFrom') as string,
                useWidthCoefficient: true,
            },
            width: 100,
            ellipsis: true,
            customRender: (data: any) => data != null ? data : '',
        },
        {
            dataIndex: 'commonParams.autoApprovalParams.marginChangeTo',
            slots: {
                title: 'commonParams.autoApprovalParams.marginChangeToColumnTitle',
            },
            slotColumnTitleData: {
                text: this.$t('regular.columns.autoApprovalMarginTo') as string,
                useWidthCoefficient: true,
            },
            width: 100,
            ellipsis: true,
            customRender: (data: any) => data != null ? data : '',
        },
        {
            dataIndex: 'commonParams.autoApprovalParams.profitabilityFrom',
            slots: {
                title: 'commonParams.autoApprovalParams.profitabilityFromColumnTitle',
            },
            slotColumnTitleData: {
                text: this.$t('regular.columns.autoApprovalMinProfFrom') as string,
                useWidthCoefficient: true,
            },
            width: 120,
            ellipsis: true,
            customRender: (data: any) => data != null ? data : '',
        },
        {
            dataIndex: 'commonParams.autoApprovalParams.profitabilityTo',
            slots: {
                title: 'commonParams.autoApprovalParams.profitabilityToColumnTitle',
            },
            slotColumnTitleData: {
                text: this.$t('regular.columns.autoApprovalMinProfTo') as string,
                useWidthCoefficient: true,
            },
            width: 120,
            ellipsis: true,
            customRender: (data: any) => data != null ? data : '',
        },
        {
            dataIndex: 'commonParams.autoApprovalParams.piFrom',
            slots: {
                title: 'commonParams.autoApprovalParams.piFromColumnTitle',
            },
            slotColumnTitleData: {
                text: this.$t('regular.columns.autoApprovalPiFrom') as string,
                useWidthCoefficient: true,
            },
            width: 100,
            ellipsis: true,
            customRender: (data: any) => data != null ? data : '',
        },
        {
            dataIndex: 'commonParams.autoApprovalParams.piTo',
            slots: {
                title: 'commonParams.autoApprovalParams.piToColumnTitle',
            },
            slotColumnTitleData: {
                text: this.$t('regular.columns.autoApprovalPiTo') as string,
                useWidthCoefficient: true,
            },
            width: 100,
            ellipsis: true,
            customRender: (data: any) => data != null ? data : '',
        },
        {
            dataIndex: 'commonParams.autoApprovalParams.revaluationEfficiencyCheck',
            slots: {
                title: 'commonParams.autoApprovalParams.revaluationEfficiencyCheckColumnTitle',
            },
            slotColumnTitleData: {
                text: this.$t('regular.columns.autoApprovalPriceTagCost') as string,
                useWidthCoefficient: true,
            },
            width: 120,
            ellipsis: true,
            customRender: (data: any) => this.toYesOrNo(data),
        },
    ]

    get individualFields(): any[] {
        const internalCodeCol = {
            dataIndex: 'internalCode',
            slots: { title: 'internalCodeColumnTitle' },
            slotColumnTitleData: { text: this.$t('regular.columns.internalProductCode') as string, useWidthCoefficient: true },
            width: 140,
            ellipsis: true,
        };
        const cartNameCol = {
            dataIndex: 'cartName',
            slots: { title: 'cartNameColumnTitle' },
            slotColumnTitleData: { text: this.$t('regular.columns.cartName') as string, useWidthCoefficient: true },
            width: 100,
            ellipsis: true,
            customRender: (val: string | null | undefined) => (val != null ? val : '-'),
        };
        const base = [this.fields[0], internalCodeCol, ...this.fields.slice(1)];
        const endDateIdx = base.findIndex((c: any) => c.dataIndex === 'commonParams.strategyValidityEndDate');
        if (endDateIdx === -1) {
            return [...base, cartNameCol];
        }
        return [...base.slice(0, endDateIdx + 1), cartNameCol, ...base.slice(endDateIdx + 1)];
    }

    individualConfigFields: any[] = [
        {
            dataIndex: 'internalCode',
            title: this.$t('regular.columns.internalCode') as string,
            sortable: true,
        },
        {
            dataIndex: 'config.priceOpt',
            title: this.$t('regular.columns.priceOptStrategy') as string,
            customRender: (data: StrategyOfPriceOpt) => strategyOfPriceOptLabels[data],
        },
        {
            dataIndex: 'config.marginalProfit',
            title: this.$t('regular.columns.minSkuProfit') as string,
        },
        {
            dataIndex: 'config.priceIncreaseLimit',
            title: this.$t('regular.columns.increaseLimit') as string,
        },
        {
            dataIndex: 'config.periodPriceIncreaseLimit',
            title: this.$t('regular.columns.periodIncreaseLimitPercent') as string,
        },
        {
            dataIndex: 'config.period',
            title: this.$t('regular.columns.period') as string,
            customRender: this.formatPeriod,
        },
    ];

    private selectedUser: string = '';
    private selectedStoreFormat: Array<number> = [];
    private selectedStoreRegion: Array<number> = [];

    private selectedStoreCluster: Array<number> = [];
    private selectedGroups: Array<number> = [];

    private selectedCategory: Array<number> = [];
    private selectedSubcategory: number | null = null;

    // Track "select all" states separately
    private isStoreFormatSelectAll: boolean = false;
    private isStoreRegionSelectAll: boolean = false;
    private isStoreClusterSelectAll: boolean = false;
    private isGroupsSelectAll: boolean = false;
    private isCategoriesSelectAll: boolean = false;

    // Individual tab: independent filter state
    private selectedStoreFormatIndividual: Array<number> = [];
    private selectedStoreRegionIndividual: Array<number> = [];
    private selectedStoreClusterIndividual: Array<number> = [];
    private selectedGroupsIndividual: Array<number> = [];
    private selectedCategoryIndividual: Array<number> = [];
    private selectedSubcategoryIndividual: number | null = null;
    private isStoreFormatSelectAllIndividual: boolean = false;
    private isStoreRegionSelectAllIndividual: boolean = false;
    private isStoreClusterSelectAllIndividual: boolean = false;
    private isGroupsSelectAllIndividual: boolean = false;
    private isCategoriesSelectAllIndividual: boolean = false;

    private isFiltersChanged = 1;

    // Unified filter configuration
    private filterConfigs: { [key: string]: any } = {
        storeFormat: {
            selectedProperty: 'selectedStoreFormat',
            selectAllProperty: 'isStoreFormatSelectAll',
            optionsProperty: 'storeFormats',
            queryProperty: 'sfid'
        },
        storeRegion: {
            selectedProperty: 'selectedStoreRegion',
            selectAllProperty: 'isStoreRegionSelectAll',
            optionsProperty: 'storeRegions',
            queryProperty: 'srid'
        },
        storeCluster: {
            selectedProperty: 'selectedStoreCluster',
            selectAllProperty: 'isStoreClusterSelectAll',
            optionsProperty: 'storeClusters',
            queryProperty: 'scid'
        },
        groups: {
            selectedProperty: 'selectedGroups',
            selectAllProperty: 'isGroupsSelectAll',
            optionsProperty: 'groups',
            queryProperty: 'gids'
        },
        category: {
            selectedProperty: 'selectedCategory',
            selectAllProperty: 'isCategoriesSelectAll',
            optionsProperty: 'categories',
            queryProperty: 'cid'
        }
    };

    private filterConfigsIndividual: { [key: string]: any } = {
        storeFormat: {
            selectedProperty: 'selectedStoreFormatIndividual',
            selectAllProperty: 'isStoreFormatSelectAllIndividual',
            optionsProperty: 'storeFormats',
            queryProperty: 'sfid'
        },
        storeRegion: {
            selectedProperty: 'selectedStoreRegionIndividual',
            selectAllProperty: 'isStoreRegionSelectAllIndividual',
            optionsProperty: 'storeRegions',
            queryProperty: 'srid'
        },
        storeCluster: {
            selectedProperty: 'selectedStoreClusterIndividual',
            selectAllProperty: 'isStoreClusterSelectAllIndividual',
            optionsProperty: 'storeClusters',
            queryProperty: 'scid'
        },
        groups: {
            selectedProperty: 'selectedGroupsIndividual',
            selectAllProperty: 'isGroupsSelectAllIndividual',
            optionsProperty: 'groups',
            queryProperty: 'gids'
        },
        category: {
            selectedProperty: 'selectedCategoryIndividual',
            selectAllProperty: 'isCategoriesSelectAllIndividual',
            optionsProperty: 'categories',
            queryProperty: 'cid'
        }
    };

    mounted() {
        if (this.selectTradingId !== -1 && this.selectTradingId !== null) {
            this.resetData();
            this.getErrorLogFileId();
            this.getErrorLogFileIdForIndividualParamsDownload();
        }
        this.resetData();
        this.getFiles({ perPage: 50, currentPage: 1 }, () => {})
        EventBus.$on('onCalcParamsSaved', this.reset)
        EventBus.$on('file', this.onFileEventReceived);
        this.refreshParamsListTable();
    }

    // Generic filter methods
    private getFilterOptions(filterType: string): any[] {
        const config = this.filterConfigs[filterType];
        if (!config) return [];
        return (this as any)[config.optionsProperty] || [];
    }

    private getSelectedValues(filterType: string, context: 'regular' | 'individual' = 'regular'): any[] {
        const config = (context === 'individual' ? this.filterConfigsIndividual : this.filterConfigs)[filterType];
        if (!config) return [];

        const selected = (this as any)[config.selectedProperty] || [];
        return selected.map((item: any) =>
            typeof item === 'object' && item !== null && 'id' in item ? item.id : item
        );
    }

    private getSelectAllFlag(filterType: string, context: 'regular' | 'individual' = 'regular'): boolean {
        const config = (context === 'individual' ? this.filterConfigsIndividual : this.filterConfigs)[filterType];
        if (!config) return false;
        return (this as any)[config.selectAllProperty] || false;
    }

    private setSelectedValues(filterType: string, values: any[], context: 'regular' | 'individual' = 'regular'): void {
        const config = (context === 'individual' ? this.filterConfigsIndividual : this.filterConfigs)[filterType];
        if (!config) return;
        (this as any)[config.selectedProperty] = values;
    }

    private setSelectAllFlag(filterType: string, value: boolean, context: 'regular' | 'individual' = 'regular'): void {
        const config = (context === 'individual' ? this.filterConfigsIndividual : this.filterConfigs)[filterType];
        if (!config) return;
        (this as any)[config.selectAllProperty] = value;
    }

    // Generic "select all" handler
    onSelectAllChange(filterType: string, checked: boolean, context: 'regular' | 'individual' = 'regular'): void {
        this.setSelectAllFlag(filterType, checked, context);
        if (checked) {
            this.selectAllForFilter(filterType, context);
        } else {
            this.setSelectedValues(filterType, [], context);
        }
    }

    // Generic select all method
    selectAllForFilter(filterType: string, context: 'regular' | 'individual' = 'regular'): void {
        this.setSelectedValues(filterType, [], context);
    }

    // Generic method to check if all items are selected
    isAllSelected(filterType: string, context: 'regular' | 'individual' = 'regular'): boolean {
        if (this.getSelectAllFlag(filterType, context)) {
            return true;
        }
        const options = this.getFilterOptions(filterType);
        const selectedValues = this.getSelectedValues(filterType, context);
        const availableValues = options
            .filter(item => item.value !== -1 && item.value !== -2)
            .map(item => item.value);
        return availableValues.length > 1 && availableValues.every(value => selectedValues.includes(value));
    }

    isFilterEmpty(filterType: string, context: 'regular' | 'individual'): boolean {
        return this.getSelectedValues(filterType, context).length === 0 && !this.getSelectAllFlag(filterType, context);
    }

    // Generic visual values getter
    getVisualSelectedValues(filterType: string, context: 'regular' | 'individual' = 'regular'): any[] {
        if (this.getSelectAllFlag(filterType, context)) {
            const options = this.getFilterOptions(filterType);
            return options
                .filter(item => item.value !== -1 && item.value !== -2)
                .map(item => item.value);
        }
        return this.getSelectedValues(filterType, context);
    }

    // Generic visual values setter
    setVisualSelectedValues(filterType: string, values: any[], context: 'regular' | 'individual' = 'regular'): void {
        this.setSelectAllFlag(filterType, false, context);
        this.setSelectedValues(filterType, values, context);
    }

    // Collect all filter data into a single object
    collectFilterData(context: 'regular' | 'individual' = 'regular'): ParametersListFilterData {
        const filterData: ParametersListFilterData = {};
        const sub = context === 'individual' ? this.selectedSubcategoryIndividual : this.selectedSubcategory;

        if (this.getSelectedValues('groups', context).length && !this.getSelectAllFlag('groups', context)) {
            filterData.gids = this.getSelectedValues('groups', context);
        }

        if (this.getSelectedValues('category', context).length > 0 && !this.getSelectAllFlag('category', context)) {
            filterData.cids = this.getSelectedValues('category', context);
        }

        if (sub != null) {
            filterData.subcids = [sub];
        }

        if (this.getSelectedValues('storeFormat', context).length > 0 && !this.getSelectAllFlag('storeFormat', context)) {
            filterData.sfids = this.getSelectedValues('storeFormat', context);
        }

        if (this.getSelectedValues('storeRegion', context).length > 0 && !this.getSelectAllFlag('storeRegion', context)) {
            filterData.srids = this.getSelectedValues('storeRegion', context);
        }

        if (this.getSelectedValues('storeCluster', context).length > 0 && !this.getSelectAllFlag('storeCluster', context)) {
            filterData.scids = this.getSelectedValues('storeCluster', context);
        }

        return filterData;
    }

    // Collect applied filters for backend requests
    collectAppliedFilters(context: 'regular' | 'individual' = 'regular'): AppliedFiltersData {
        const appliedFilters: AppliedFiltersData = {};
        const sub = context === 'individual' ? this.selectedSubcategoryIndividual : this.selectedSubcategory;

        if (this.getSelectedValues('groups', context).length && !this.getSelectAllFlag('groups', context)) {
            appliedFilters.selectedGroups = this.getSelectedValues('groups', context);
        }

        if (this.getSelectedValues('category', context).length > 0 && !this.getSelectAllFlag('category', context)) {
            appliedFilters.selectedCategories = this.getSelectedValues('category', context);
        }

        if (sub != null) {
            appliedFilters.selectedSubcategories = [sub];
        }

        if (this.getSelectedValues('storeFormat', context).length > 0 && !this.getSelectAllFlag('storeFormat', context)) {
            appliedFilters.selectedStoreFormats = this.getSelectedValues('storeFormat', context);
        }

        if (this.getSelectedValues('storeRegion', context).length > 0 && !this.getSelectAllFlag('storeRegion', context)) {
            appliedFilters.selectedStoreRegions = this.getSelectedValues('storeRegion', context);
        }

        if (this.getSelectedValues('storeCluster', context).length > 0 && !this.getSelectAllFlag('storeCluster', context)) {
            appliedFilters.selectedStoreClusters = this.getSelectedValues('storeCluster', context);
        }

        return appliedFilters;
    }

    /** Списки ID для выгрузки: при «Выбрать всё» — все опции; иначе — только явный выбор; параметр не нужен, если пусто и не select-all. */
    private idsForParamsListDownload(filterType: string, context: 'regular' | 'individual' = 'regular'): number[] | undefined {
        if (this.getSelectAllFlag(filterType, context)) {
            const options = this.getFilterOptions(filterType);
            const ids = options
                .filter((item) => item.value !== -1 && item.value !== -2)
                .map((item) => item.value);
            return ids.length > 0 ? ids : undefined;
        }
        const selected = this.getSelectedValues(filterType, context);
        return selected.length > 0 ? selected : undefined;
    }

    private applyIndividualDownloadFilters(filters: FindFiltersParams, context: 'regular' | 'individual' = 'regular'): void {
        const gids = this.idsForParamsListDownload('groups', context);
        if (gids != null) {
            filters.groupsOfProduct = gids;
            filters.groupOfProduct = null;
        }

        const cids = this.idsForParamsListDownload('category', context);
        if (cids != null) {
            filters.categories = cids;
            filters.category = null;
        }

        const sfids = this.idsForParamsListDownload('storeFormat', context);
        if (sfids != null) {
            filters.storeFormatValues = sfids;
            filters.storeFormat = null;
        }

        const srids = this.idsForParamsListDownload('storeRegion', context);
        if (srids != null) {
            filters.storeRegionValues = srids;
        }

        const scids = this.idsForParamsListDownload('storeCluster', context);
        if (scids != null) {
            filters.storeClusterValues = scids;
            filters.storeCluster = null;
        }
    }

    tableFields() {
        const tableFields: ITableHeaders[] = [
            { dataIndex: 'id', title:"№", width: 100, scopedSlots: { customRender: 'id'}},
            { dataIndex: 'filePath', title: this.$t('regular.columns.fileName') as string, width: 100, scopedSlots: { customRender: 'filePath' }},
            { dataIndex: 'statusMessage', title: this.$t('regular.columns.status') as string, width: 100, scopedSlots: { customRender: 'statusMessage' }},
            { dataIndex: 'action', title: '', width: 100, scopedSlots: { customRender: 'action' }},
        ]

        return tableFields
    }

    showPercentsProgressOrStatus(row: ServerFile): string {
        const isProcessing = isWritingToDatabase(row.statusMessage) || row.status === 'WRITE_TO_DATABASE';
        if (isProcessing && row.progress) {
            return row.progress;
        }
        return localizeFileStatusMessage(row.statusMessage) + '. ' + row.warnings;
    }

    getFiles(ctx: any, callback: (items: any[]) => void) {
        const pageParams: FilesPageParams = {
            type: this.fileType, size: ctx.perPage, page: ctx.currentPage - 1,
        };
        this.httpGetFileList(pageParams)
            .then((response) => {
                this.filesTable = response.data.content;
                this.filesTableTotalRows = response.data.totalElements;
                callback(response.data.content);
            })
            .catch((e) => {
                this.showError(this.$t('regular.errors.loadFileListFailed') as string);
                callback([]);
            });
    }

    beforeDeleteFileDialog(fileId: number) {
        this.fileIdForDelete = fileId;
        this.showDeleteFileModal = true;

    }

    showDeleteFileDialog(fileId: number) {
        this.deleteFile(fileId);
    }

    deleteFile(taskId: number) {
        this.httpDeleteFile(taskId)
            .then(() => {
                this.filesTable = this.filesTable.filter((item) => {
                    return item.id !== taskId;
                });
                (this.$refs.filesTable as any).refresh();

            })
            .catch((e) => {
                this.showError(this.$t('regular.errors.deleteFileFailed') as string);
            });
    }

    disableDeleteButtonConditions(row: ServerFile): boolean {
        return row.status === 'IN_QUEUE_TO_DELETE' || row.status === 'DELETE_FILE' || row.status === 'DELETE_ON_ERROR'
    }

    onFileEventReceived(d: ServerFile) {
        this.updateFilesTableRowStatus(d);
        // this.getErrorLogFileId()
        this.refreshParamsListTable();
    }

    openIndividualConfigModal(item: any) {
        this.loadIndividualConfigs({apiUrl: item.id}, () => {})
        this.showIndividualConfigModal = true
    }

    updateFilesTableRowStatus(data: ServerFile) {
        const index = this.filesTable.findIndex((item) => {
            return item.id === data.id;
        });
        if (index === -1) {
            this.filesTable = [data, ...this.filesTable];
            return;
        }
        this.filesTable[index].statusMessage = data.statusMessage;
        if (data.warnings) {
            this.filesTable[index].statusMessage += data.warnings;
        }
        this.refreshFilesTable()
    }

    handleFilter() {       
        this.isFiltersChanged = 1;
        this.rulesListPagination.current = 1;
        this.fetchList({}, () => {})
    }

    refreshTables() {
        this.refreshFilesTable()
        this.refreshParamsListTable()
    }

    refreshFilesTable() {
        this.getFiles({ perPage: 50, currentPage: 1 }, () => {})
    }

    refreshParamsListTable() {
        this.noNeedToLoad = true;
        this.rulesListPagination.current = 1;
        this.fetchList({}, () => {});
    }

    onRulesTableChange(pagination: any) {
        this.rulesListPagination.current = pagination && pagination.current ? pagination.current : 1;
        this.rulesListPagination.pageSize = pagination && pagination.pageSize
            ? pagination.pageSize
            : this.rulesListPagination.pageSize;
        this.fetchList({}, () => {});
    }

    onParamsListTabChange(activeKey: string) {
        this.activeParamsListTabKey = activeKey;
        if (activeKey === 'filesTabRef') {
            this.getFiles({ perPage: 50, currentPage: 1 }, () => {});
        } else if (activeKey === 'skuTabsRef') {
            this.refreshParamsListTable();
        } else if (activeKey === 'individualParamsTabRef') {
            this.refreshIndividualParamsListTable();
        }
    }

    refreshIndividualParamsListTable() {
        this.noNeedToLoad = true;
        this.fetchIndividualList({}, () => {});
    }

    getErrorLogFileId() {
        if (this.selectTradingId !== -1 && this.selectTradingId !== null) {
            this.httpGetFileIdErrorsForRulesList(this.selectTradingId)
                .then((r) => {
                        this.fileId = r.data;
                    },
                )
                .catch((e) => {
                    this.showError(this.$t('regular.errors.loadErrorFileFailed') as string);
                    this.$log.error('Error occurred [load error text file]', e);
                });
        }
    }

    getErrorLogFileIdForIndividualParamsDownload() {
        if (this.selectTradingId !== -1 && this.selectTradingId !== null) {
            this.httpGetErrorFileIdForIndividualParamsDownload(this.selectTradingId)
                .then((r) => {
                        this.individualParamsFileId = r.data;
                    },
                )
                .catch((e) => {
                    this.showError(this.$t('regular.errors.loadErrorFileFailed') as string);
                    this.$log.error('Error occurred [load error text file]', e);
                });
        }
    }

    beforeDestroy() {
        EventBus.$off('onCalcParamsSaved', this.reset)
        EventBus.$off('file', this.onFileEventReceived);
    }

    load() {
        if (!this.noNeedToLoad) {
            this.noNeedToLoad = true;
            (this.$refs.paramsListTable as any).$forceUpdate();
        }
    }

    reset() {
        this.noNeedToLoad = false;
    }

    fetchList(ctx: any, callback: (items: ParamsListItem[]) => void) {
        if (!this.noNeedToLoad || this.selectTradingId === null || this.selectTradingId === -1) {
            this.tableDataRulesListTable = []
            callback([]);
            return;
        }
        if (this.isFiltersChanged === 0) {
            this.tableDataRulesListTable = this.rulesListTable
            return;
        }
        (this.$refs.statusModal as any).show();
        const query: ParametersListQuery = new ParametersListQuery();
        query.limit = this.rulesListPagination.pageSize;
        query.offset = (this.rulesListPagination.current - 1) * this.rulesListPagination.pageSize;
        query.tnId = this.selectTradingId;
        let filterData: ParametersListFilterData = this.collectFilterData();
        this.httpFetchParametersList(filterData, query)
            .then((res: AxiosResponse<Page<ParamsListItem[]>>) => {
              this.rulesListPagination.total = res.data.totalElements;
              this.rulesListTableSize = res.data.content.length;
              this.rulesListTable = res.data.content;
              this.tableDataRulesListTable = res.data.content;
              callback(res.data.content);
              this.loadBaseFilterOptions();
            })
            .catch(() => {
                this.tableDataRulesListTable = []
                callback([]);
            })
            .finally(() => {
              (this.$refs.statusModal as any).hide();
            });
    }

    fetchIndividualList(ctx: any, callback: (items: ParamsListItem[]) => void) {
        if (!this.noNeedToLoad || this.selectTradingId === null || this.selectTradingId === -1) {
            this.individualRulesListTable = [];
            this.individualRulesListTableSize = 0;
            callback([]);
            return;
        }
        if (this.isFiltersChanged === 0) {
            this.tableDataIndividualRulesListTable = this.individualRulesListTable;
            return;
        }
        (this.$refs.statusModal as any).show();
        const query: ParametersListQuery = new ParametersListQuery();
        query.limit = 1000;
        query.offset = 0;
        query.tnId = this.selectTradingId;
        const filterData: ParametersListFilterData = this.collectFilterData('individual');
        this.httpFetchIndividualParametersList(filterData, query)
            .then((res: AxiosResponse<Page<ParamsListItem[]>>) => {
                this.individualRulesListTotalRows = res.data.totalElements;
                this.individualRulesListTableSize = res.data.content.length;
                this.individualRulesListTable = res.data.content;
                this.tableDataIndividualRulesListTable = res.data.content;
                callback(res.data.content);
                this.loadBaseFilterOptionsIndividual();
            })
            .catch(() => {
                this.individualRulesListTable = [];
                this.individualRulesListTableSize = 0;
                callback([]);
            })
            .finally(() => {
                (this.$refs.statusModal as any).hide();
            });
    }

    handleIndividualFilter() {
        this.isFiltersChanged = 1;
        this.fetchIndividualList({}, () => {});
    }

    applyFilters() {
        this.filtersApplied = true;
        if (this.activeParamsListTabKey === 'individualParamsTabRef') {
            this.loadBaseFilterOptionsIndividual();
            this.refreshIndividualParamsListTable();
        } else {
            this.loadBaseFilterOptions();
            this.refreshParamsListTable();
        }
    }

    resetFilters() {
        this.filtersApplied = false;
        if (this.activeParamsListTabKey === 'individualParamsTabRef') {
            this.selectedSubcategoryIndividual = null;
            Object.keys(this.filterConfigsIndividual).forEach(filterType => {
                this.setSelectedValues(filterType, [], 'individual');
                this.setSelectAllFlag(filterType, false, 'individual');
            });
            this.loadBaseFilterOptionsIndividual();
            this.refreshIndividualParamsListTable();
        } else {
            this.selectedSubcategory = null;
            Object.keys(this.filterConfigs).forEach(filterType => {
                this.setSelectedValues(filterType, [], 'regular');
                this.setSelectAllFlag(filterType, false, 'regular');
            });
            this.loadBaseFilterOptions();
            this.refreshParamsListTable();
        }
    }

    singleIdAndNameFormatter(value: IdAndName | null): string {
        if (value == null) {
            return '';
        }
        return value.name;
    }

    multipleIdAndNameFormatter(value: IdAndName[] | null): string {
        if (value == null) {
            return '';
        }
        // tslint:disable-next-line: no-shadowed-variable
        return value.map((value: IdAndName) => value.name).join(', ')
    }

    show(value: any, key: string, item: ParamsListItem, formatter?: (data: any) => any): any | null {
        const actualKey = key.replace('commonParams.', '')
        if (item.diff.indexOf(actualKey) === -1) {
            return null
        }
        if (formatter != null) {
            return formatter(value)
        } else {
            return value
        }
    }

    toggleDescClass(field: TableHeaders) {
        if (!field.hasOwnProperty('thClass')) {
            field.thClass = ['desc'];
            return
        }
// tslint:disable-next-line: no-non-null-assertion
        const index: number = field.thClass!!.indexOf('desc')
        if (index !== -1) {
// tslint:disable-next-line: no-non-null-assertion
            field.thClass!!.splice(index, 1);
        } else {
// tslint:disable-next-line: no-non-null-assertion
            field.thClass!!.push('desc')
        }
    }

    openIndividualConfigs(row: any) {
        this.showWindow = true;
    }

    loadIndividualConfigs(ctx: any, callback: (items: IIndividualConfigsDAO[]) => void) {
// tslint:disable-next-line: radix
        const id = parseInt(ctx.apiUrl);
        if (!(id in this.individualParams)) {
            this.individualParams[id] = {
                array: [],
                dictionary: {},
            };
            this.httpFetchIndividualByBaseId(id)
                .then((res: AxiosResponse<CalcIndividualConfigMap>) => {
                    if (res.status === 200) {
                        const items: IIndividualConfigsDAO[] = [];
                        Object.keys(res.data).forEach((key: string) => {
                            const params: CalcIndividualConfig = res.data[key];
                            items.push({
                                internalCode: key,
                                config: params,
                            })
                        })
                        this.individualParams[id] = {
                            array: items,
                            dictionary: res.data,
                        }
                        this.individualConfigArray = this.individualParams[id].array
                        callback(items.sort((a: IIndividualConfigsDAO, b: IIndividualConfigsDAO) => this.sort(a, b, ctx.sortDesc)));
                    }
                })
                .catch(() => {
                    callback([]);
                });
        } else {
            callback(this.individualParams[id].array.sort((a: IIndividualConfigsDAO, b: IIndividualConfigsDAO) => this.sort(a, b, ctx.sortDesc)));
        }
    }

    sort(a: IIndividualConfigsDAO, b: IIndividualConfigsDAO, desc: boolean): number {
        return -1
    }

    editRule(rule: ParamsListItem) {
        this.applyCommonParams(rule);
        this.$emit('goToParams', '')
    }

    editIndividual(rule: ParamsListItem, sku: IIndividualConfigsDAO) {
        const id = rule.individualId;
        if (id != null && id in this.individualParams) {
            const calc = this.applyCommonParams(rule);
            this.applyBaseIndividualConfig(calc, this.individualParams[id].dictionary);
            this.$emit('goToSkuList', sku.internalCode);
        }
    }

    downloadParams() {
        if (this.selectTradingId !== -1 && this.selectTradingId !== null) {
            const filters: ParametersListQuery = new ParametersListQuery();
            filters.tnId = this.selectTradingId;
            const gids = this.idsForParamsListDownload('groups');
            if (gids != null) {
                filters.gids = gids;
            }

            const cids = this.idsForParamsListDownload('category');
            if (cids != null) {
                filters.cids = cids;
            }

            if (this.selectedSubcategory != null) {
                filters.subcids = [this.selectedSubcategory];
            }

            const sfids = this.idsForParamsListDownload('storeFormat');
            if (sfids != null) {
                filters.sfids = sfids;
            }

            const srids = this.idsForParamsListDownload('storeRegion');
            if (srids != null) {
                filters.srids = srids;
            }

            const scids = this.idsForParamsListDownload('storeCluster');
            if (scids != null) {
                filters.scids = scids;
            }

            // if (this.selectedUser !== '') {
            //     filters.updatedBy = this.selectedUser;
            // }
            this.$http.post('/api/filters/paramsListDownload', filters, {
                method: 'POST',
                responseType: 'blob',
            })
                .then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', this.$t('regular.files.filtersXlsx') as string);
                    document.body.appendChild(link);
                    link.click();
                })
                .catch((e) => {
                    this.showError(this.$t('regular.errors.downloadReportFailed') as string);
                });
        }
    }

    downloadIndividualParamsFromTab() {
        if (this.selectTradingId !== -1 && this.selectTradingId !== null) {
            const filters = new FindFiltersParams();
            filters.tradingId = this.selectTradingId;
            this.applyIndividualDownloadFilters(filters, 'individual');

            if (this.selectedSubcategoryIndividual != null) {
                filters.subcategories = [this.selectedSubcategoryIndividual];
            }

            this.$http.post('/api/filters/individualParamsListDownload', filters, {
                method: 'POST',
                responseType: 'blob',
            })
                .then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', this.$t('regular.files.individualFiltersXlsx') as string);
                    document.body.appendChild(link);
                    link.click();
                })
                .catch((e) => {
                    this.showError(this.$t('regular.errors.downloadReportFailed') as string);
                });
        }
    }

    downloadIndividualParams() {
        if (this.selectTradingId !== -1 && this.selectTradingId !== null) {
            const filters = new FindFiltersParams();
            filters.tradingId = this.selectTradingId;
            this.applyIndividualDownloadFilters(filters, 'regular');

            if (this.selectedSubcategory != null) {
                filters.subcategories = [this.selectedSubcategory];
            }

            this.$http.post('/api/filters/individualParamsListDownload', filters, {
                method: 'POST',
                responseType: 'blob',
            })
                .then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', this.$t('regular.files.individualFiltersXlsx') as string);
                    document.body.appendChild(link);
                    link.click();
                })
                .catch((e) => {
                    this.showError(this.$t('regular.errors.downloadReportFailed') as string);
                });
        }
    }

    downloadErrorLog(fileId: number) {
        this.$http.get('/api/error/list', {
            method: 'GET',
            responseType: 'blob',
            params: {
                fileId,
            },
        }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', this.$t('regular.columns.errors') as string);

            document.body.appendChild(link);
            link.click();
        })
            .catch((e) => {
                this.showError(this.$t('regular.errors.getErrorLogFailed') as string);
            });
    }

    uploadFile(file: File) {
        if (!file) {
            this.showInfo(this.$t('regular.common.selectFile') as string);
            return;
        }
        const uploadFile = new FormData();
        this.loadProgress = true;
        const size = file.size;
        uploadFile.append('file', new Blob([file]), file.name);
        const self = this;
        const onUploadProgress = (e: any) => {
            const s = e.loaded / size;
            self.progressCounter = (s * 100) > 100 ? 100 : Math.round(s * 100);
        };

        // tslint:disable-next-line: no-non-null-assertion
        this.httpUploadFile(this.selectTradingId!!, FileType.RULES, uploadFile, onUploadProgress)
            .then(() => {
                this.refreshFilesTable();
                this.file = null;
                this.$nextTick(() => {
                    this.loadProgress = false;
                    this.progressCounter = 0;
                });
            })
            .catch((e) => {
                this.showError(this.$t('regular.errors.loadFileFailedSpace') as string);
                this.loadProgress = false;
                this.progressCounter = 0;
                this.file = null;
                (this.$refs.fileinput as BFormFile).reset();
            });

    }

    disableUploadButtons(): boolean {
      return !this.file || !this.selectTradingId
    }

    uploadIndividualParamsFile(event: Event) {
      event.preventDefault();
      if (!this.file) {
        this.showInfo(this.$t('regular.common.selectFile') as string);
        return;
      }
      const uploadFile = new FormData();
      this.loadProgress = true;
      const size = this.file.size;
      uploadFile.append(
          'file',
          new Blob([this.file]),
          this.file.name
      );
      const self = this;
      const onUploadProgress = (e: any) => {
        const s = e.loaded / size;
        self.progressCounter = (s * 100) > 100 ? 100 : Math.round(s * 100);
      };

      // tslint:disable-next-line: no-non-null-assertion
      this.httpUploadFile(this.selectTradingId!!, FileType.INDIVIDUALPARAMS, uploadFile, onUploadProgress)
          .then(() => {
            (this.$refs.fileinput as BFormFile).reset();
            this.file = null;
            this.$nextTick(() => {
              this.loadProgress = false;
              this.progressCounter = 0;
            });
            this.refreshParamsListTable()
            this.showInfo(this.$t('regular.notifications.indivParamsLoaded') as string)
          })
          .catch((e) => {
            this.showError(this.$t('regular.errors.loadFileFailedSpace') as string);
            this.loadProgress = false;
            this.progressCounter = 0;
            this.file = null;
            (this.$refs.fileinput as BFormFile).reset();
          });

    }

    private applyCommonParams(rule: ParamsListItem): Calc {
        this.$calc = this.getCalcDefaultData();
        const calc: Calc = this.getCalcDefaultData();
        calc.selectMarket = {
            editable: true,
            id: rule.tradingNetwork.id,
            tradingName: rule.tradingNetwork.name,
            isDefault: false,
        };
        calc.groupOfProduct = rule.group ? rule.group.id : null;
        calc.categoryOfProduct = rule.category ? rule.category.id : null;
        const subcategories = rule.subcategories ? rule.subcategories.map((item: IdAndName) => item.id) : [];
// tslint:disable-next-line: no-non-null-assertion
        calc.subcategories = LocalData.filterNumberArrays(subcategories)!;
        calc.formatSelected = rule.storeFormat ? rule.storeFormat.id : null;
        const storeRegions = rule.storeRegions ? rule.storeRegions.map((item: IdAndName) => item.id) : [];
// tslint:disable-next-line: no-non-null-assertion
        calc.regionSelected = LocalData.filterNumberArrays(storeRegions)!;
        calc.clusterSelected = rule.storeCluster ? rule.storeCluster.id : null;
        calc.categoryStrategy = categoryStrategiesSet[rule.categoryStrategy];
        this.applyCalcFilters(calc, rule.commonParams);
        EventBus.$emit('tradingNetChanged', calc.selectMarket);
        this.$calc = calc;
        return calc;
    }

    private formatPeriod(data: number): string {
        const sb = this.periodOptions.find((item: SelectBox<number>) => item.value === data)
        return sb ? sb.label : '';
    }

    private formatStrategyValidityDate(data: string | number | null): string {
        return data ? new Date(data).toLocaleString('ru-RU') : '';
    }

    private loadUsers() {
        this.httpGetUpdatedByUserInfo(this.selectTradingId!!)
            .then((response) => {
                const filterData = response.data;
                this.users = [this.defaultStringSelectBox, ...filterData.updatedByUsers.map((i) => {
                    return {value: i, label: i}
                })];
                console.log("USERS ", this.users)
            })
            .catch((e) => {
            })
    }

    private loadBaseFilterOptions() {
        const appliedFilters = this.collectAppliedFilters();
        
        this.httpGetBaseFilterOptions(this.selectTradingId!!, appliedFilters)
            .then((data) => {
                const filterOptions = data.data;
                
                // Unified mapping function
                const mapFilterOptions = (items: IdAndName[]) => items.map(i => ({value: i.id, label: i.name}));
                
                // Load all filter options using unified function
                this.groups = mapFilterOptions(filterOptions.groups);
                this.categories = mapFilterOptions(filterOptions.categories);
                this.subcategories = mapFilterOptions(filterOptions.subcategories);
                this.storeFormats = mapFilterOptions(filterOptions.storeFormats);
                this.storeRegions = mapFilterOptions(filterOptions.storeRegions);
                this.storeClusters = mapFilterOptions(filterOptions.storeClusters);
            })
            .catch((e) => {
                this.showError(this.$t('regular.errors.loadBaseFiltersFailed') as string);
            })
    }

    private loadBaseFilterOptionsIndividual() {
        const appliedFilters = this.collectAppliedFilters('individual');

        this.httpGetBaseFilterOptionsIndividual(this.selectTradingId!!, appliedFilters)
            .then((data) => {
                const filterOptions = data.data;

                const mapFilterOptions = (items: IdAndName[]) => items.map(i => ({value: i.id, label: i.name}));

                this.groups = mapFilterOptions(filterOptions.groups);
                this.categories = mapFilterOptions(filterOptions.categories);
                this.subcategories = mapFilterOptions(filterOptions.subcategories);
                this.storeFormats = mapFilterOptions(filterOptions.storeFormats);
                this.storeRegions = mapFilterOptions(filterOptions.storeRegions);
                this.storeClusters = mapFilterOptions(filterOptions.storeClusters);
            })
            .catch((e) => {
                this.showError(this.$t('regular.errors.loadBaseFiltersFailed') as string);
            })
    }

    private getTaskInfo(type: TaskInfoFilterType): GetTaskInfo {
        return {
            type,
// tslint:disable-next-line: no-non-null-assertion
            tradingId: this.selectTradingId!!,
            categories: LocalData.filterNumberArrays(this.selectedCategory, true),
            groups: LocalData.filterNumberArrays(this.selectedGroups, true),
            subcategory: LocalData.filterNumberArrays([this.selectedSubcategory], true),
            segments: null,
            storeFormat: LocalData.filterNumberArrays(this.selectedStoreFormat, true),
            storeCluster: LocalData.filterNumberArrays(this.selectedStoreCluster, true),
            storeRegion: LocalData.filterNumberArrays(this.selectedStoreRegion, true),
            byReports: false,
            rulesListCondition: true,
        }
    }

    private resetData() {
        this.selectedGroups = [];
        this.selectedCategory = [];
        this.selectedSubcategory = null;
        this.selectedStoreFormat = [];
        this.selectedStoreRegion = [];
        this.selectedStoreCluster = [];
        // this.selectedUser = '';
        this.selectedStoreFormatIndividual = [];
        this.selectedStoreRegionIndividual = [];
        this.selectedStoreClusterIndividual = [];
        this.selectedGroupsIndividual = [];
        this.selectedCategoryIndividual = [];
        this.selectedSubcategoryIndividual = null;
        this.isStoreFormatSelectAllIndividual = false;
        this.isStoreRegionSelectAllIndividual = false;
        this.isStoreClusterSelectAllIndividual = false;
        this.isGroupsSelectAllIndividual = false;
        this.isCategoriesSelectAllIndividual = false;
        this.groups = this.defaultMultipleValue;
        this.categories = this.defaultMultipleValue;
        this.subcategories = this.defaultMultipleValue;
        this.storeFormats = this.defaultMultipleValue;
        this.storeRegions = this.defaultMultipleValue;
        this.storeClusters = this.defaultMultipleValue;
        this.users = [this.defaultStringSelectBox];
        this.loadUsers();
        this.loadBaseFilterOptions();
        this.rulesListTable = [];
    }

    get emptyMessage(): string {
        if (this.filtersApplied) {
            return this.$t('regular.notifications.noSavedRulesForFilters') as string;
        } else {
            return this.$t('regular.notifications.noSavedRules') as string;
        }
    }

    get isTradingSelected(): boolean {
        return this.selectTradingId === -1 || this.selectTradingId == null;
    }


    // Computed properties for visual checkbox values - now using generic methods
    get visualSelectedStoreFormat(): Array<number> {
        return this.getVisualSelectedValues('storeFormat');
    }

    set visualSelectedStoreFormat(value: Array<number>) {
        this.setVisualSelectedValues('storeFormat', value);
    }

    get visualSelectedStoreRegion(): Array<number> {
        return this.getVisualSelectedValues('storeRegion');
    }

    set visualSelectedStoreRegion(value: Array<number>) {
        this.setVisualSelectedValues('storeRegion', value);
    }

    get visualSelectedStoreCluster(): Array<number> {
        return this.getVisualSelectedValues('storeCluster');
    }

    set visualSelectedStoreCluster(value: Array<number>) {
        this.setVisualSelectedValues('storeCluster', value);
    }

    get visualSelectedGroups(): Array<number> {
        return this.getVisualSelectedValues('groups');
    }

    set visualSelectedGroups(value: Array<number>) {
        this.setVisualSelectedValues('groups', value);
    }

    get visualSelectedCategory(): Array<number> {
        return this.getVisualSelectedValues('category');
    }

    set visualSelectedCategory(value: Array<number>) {
        this.setVisualSelectedValues('category', value);
    }

    get visualSelectedStoreFormatIndividual(): Array<number> {
        return this.getVisualSelectedValues('storeFormat', 'individual');
    }

    set visualSelectedStoreFormatIndividual(value: Array<number>) {
        this.setVisualSelectedValues('storeFormat', value, 'individual');
    }

    get visualSelectedStoreRegionIndividual(): Array<number> {
        return this.getVisualSelectedValues('storeRegion', 'individual');
    }

    set visualSelectedStoreRegionIndividual(value: Array<number>) {
        this.setVisualSelectedValues('storeRegion', value, 'individual');
    }

    get visualSelectedStoreClusterIndividual(): Array<number> {
        return this.getVisualSelectedValues('storeCluster', 'individual');
    }

    set visualSelectedStoreClusterIndividual(value: Array<number>) {
        this.setVisualSelectedValues('storeCluster', value, 'individual');
    }

    get visualSelectedGroupsIndividual(): Array<number> {
        return this.getVisualSelectedValues('groups', 'individual');
    }

    set visualSelectedGroupsIndividual(value: Array<number>) {
        this.setVisualSelectedValues('groups', value, 'individual');
    }

    get visualSelectedCategoryIndividual(): Array<number> {
        return this.getVisualSelectedValues('category', 'individual');
    }

    set visualSelectedCategoryIndividual(value: Array<number>) {
        this.setVisualSelectedValues('category', value, 'individual');
    }

    private getLabelFromEnum(enumObj: IEnumObj, value: string): string {
        return  enumObj[value] && enumObj[value].label || value;
    }
}

interface IIndividualConfigsDAO {
    internalCode: string;
    config: CalcIndividualConfig
}

// tslint:disable-next-line: interface-name
interface IndividualConfigHolder {
    array: IIndividualConfigsDAO[];
    dictionary: CalcIndividualConfigMap;
}

// tslint:disable-next-line: interface-over-type-literal
type IndividualParamsMap = { [x: number]: IndividualConfigHolder }
